import { render, staticRenderFns } from "./correlation.vue?vue&type=template&id=74f10b6f&scoped=true"
import script from "./correlation.vue?vue&type=script&lang=js"
export * from "./correlation.vue?vue&type=script&lang=js"
import style0 from "./correlation.vue?vue&type=style&index=0&id=74f10b6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f10b6f",
  null
  
)

export default component.exports